<template>
    <div>
        <div>
            <b-form-select v-model="selected" :options="options" class="select"></b-form-select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'type',
    updated: function(){
        this.$emit('sendType', this.selected)
    },
    data: function(){
        return {
            selected: '',
            options: [
                {value: '', disabled: true, text: 'Wybierz typ'},
                {value: 'Internet', text: 'Internet'},
                {value: 'Telewizja', text: 'Telewizja'},
                {value: 'Telefonia', text: 'Telefonia'},
                {value: 'Wszystkie', text: 'Wszystkie'},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .select {
        margin-bottom: 10px;
    }
</style>